import React from 'react';
import { ICON } from '../../icons/iconIds';
import IconButton from '../icons/IconButton';
import Card from '../ui/Card';

/** Standard repo modal pattern (modal-overlay + modal-content). */
const WhosInModal = ({ title, onClose, children, className = '' }) => (
  <div className="modal-overlay" onClick={onClose} role="presentation">
    <div onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={title}>
      <Card className={`modal-content whos-in-modal-panel ${className}`.trim()}>
        <div className="whos-in-modal-header">
          <h3>{title}</h3>
          <IconButton icon={ICON.uiClose} className="close-button" onClick={onClose} ariaLabel="Close" />
        </div>
        {children}
      </Card>
    </div>
  </div>
);

export default WhosInModal;
